import axios from "axios"

export function getBrandModelDropdown({
  search
}) {
  const url = `/serialnumber/api/v1/product/brand-models/get-brand-models-dropdown-tree`;

  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: {
        search: search
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}